export default {
  emptySkill: ({ skills }) => skills.length == 0  
}